// import { ConnectComponent } from "./connectwallet.js";
import { InjectedConnector } from "@starknet-react/core";
import { StarknetConfig,} from '@starknet-react/core'
// import { ConnectWallet, handleBraavos, handleArgent } from "./components/Connectwallet.js";
import InjectWallet from './components/InjectWallet';
import ConnectionStatus from './components/ConnectionStatus';
import EcoStarknet from './components/EcoStarknet';
import StarknetEs from './components/StarknetEs';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import image1 from './stark.jpg';
import image2 from './arbitrum.jpg';
import image3 from './optimism.jpg';  
import image4 from './zksync.jpg';
import image5 from './Dydx.jpg';
import image6 from './Metis.jpg';
import image7 from './Loopring.jpg';
import image8 from './Immutable.jpg';
import logo from './logo.svg';
import backgroundImg1 from './Background.gif';
import backgroundImg2 from './Prueba2.gif';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { useState, } from 'react';
import { Card,} from 'react-bootstrap';
import { Modal, Button } from 'react-bootstrap';
//import { CSSTransition } from 'react-transition-group';
import Card1 from './Starknet.png'
import Card2 from './arbitrum.png'
import Card3 from './Optimism.png'
import Card4 from './Zksync.png'
import Card5 from './dydx.png'
import Card6 from './metis.png'
import Card7 from './loopring.png'
import Card8 from './immutable.png'




function App() {
  const connectors = [
    new InjectedConnector({ options: { id: "braavos" } }),
    new InjectedConnector({ options: { id: "argentX" } }),
  ];


    //const [isOpen, setIsOpen] = useState(false);
    //const [isWorkshopOpen, setIsWorkshopOpen] = useState(false);
    //const [isMirrorOpen, setIsMirrorOpen] = useState(false);
    //const [isYoutubeOpen, setIsYoutubeOpen] = useState(false);
    //const [isSpaceOpen, setIsSpaceOpen] = useState(false);
    //const [isContactOpen, setIsContactOpen] = useState(false);
    const [isMainOpen, setIsMainOpen] = useState(false);
    //const [isL2Open, setIsL2Open] = useState(false);
    //const [isSTOpen, setIsSTOpen] = useState(false);
    //const [isContactOpen, setIsContactOpen] = useState(false);
    //const [isGithubOpen, setIsGithubOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(null);
    const handleClick = menu => {setIsOpen(isOpen === menu ? null : menu);
};

    const [openCard,] = useState(null);
    const id1 = "1";
    const id2 = "2";
    const id3 = "3";
    const id4 = "4";
    const id5 = "5";
    const id6 = "6";
    const id7 = "7";
    const id8 = "8";
    const [showCard1, setShowCard1] = useState(false);
    const [showCard2, setShowCard2] = useState(false);
    const [showCard3, setShowCard3] = useState(false);
    const [showCard4, setShowCard4] = useState(false);
    const [showCard5, setShowCard5] = useState(false);
    const [showCard6, setShowCard6] = useState(false);
    const [showCard7, setShowCard7] = useState(false);
    const [showCard8, setShowCard8] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState("Workshop", "Mirror", "Youtube", "Space", "Contact");
  
const handleCard1Open = () => {
  setShowCard1(true);
}

const handleCard1Close = () => {
  setShowCard1(false);
}

const handleCard2Open = () => {
  setShowCard2(true);
}

const handleCard2Close = () => {
  setShowCard2(false);
}

const handleCard3Open = () => {
  setShowCard3(true);
}

const handleCard3Close = () => {
  setShowCard3(false);
}

const handleCard4Open = () => {
  setShowCard4(true);
}

const handleCard4Close = () => {
  setShowCard4(false);
}

const handleCard5Open = () => {
  setShowCard5(true);
}

const handleCard5Close = () => {
  setShowCard5(false);
}

const handleCard6Open = () => {
  setShowCard6(true);
}

const handleCard6Close = () => {
  setShowCard6(false);
}

const handleCard7Open = () => {
  setShowCard7(true);
}

const handleCard7Close = () => {
  setShowCard7(false);
}

const handleCard8Open = () => {
  setShowCard8(true);
}

const handleCard8Close = () => {
  setShowCard8(false);
  }




  const backgroundImage1 = document.querySelector(".background-image1");
  const backgroundImage2 = document.querySelector(".background-image2");
  let lastScroll = window.pageYOffset;
    
  if (backgroundImage2) {
    backgroundImage2.style.opacity = 0;
  }
    
  window.onload = function() {
    setTimeout(function() {
      window.onscroll();
    }, 200);
  };
  
  window.onscroll = function() {
    const currentScroll = window.pageYOffset;
    const scrollDifference = Math.abs(currentScroll - lastScroll);
    
    if (scrollDifference >= 400) {
      if (currentScroll > lastScroll) {
        // Scrolling down
        backgroundImage1.style.opacity = 0;
        backgroundImage2.style.opacity = 1;
        
      } else {
        // Scrolling up
        backgroundImage1.style.opacity = 1;
        backgroundImage2.style.opacity = 0;
     }
      lastScroll = currentScroll;
    }
  };


return (
     <div>
    <Navbar
    className="bg-light opacity-bar"
    expand="lg"
    onMouseEnter={() => setIsMainOpen(true)}
    onMouseLeave={() => setIsMainOpen(false)}
  >
 

  <Navbar.Brand href="#" className="nadai-starknet">Nadai Starknet</Navbar.Brand>
  <Navbar.Toggle aria-controls="basic-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav" expanded={isMainOpen}>
  <Nav className="mr-auto">
      <Dropdown className="l2-espanol"  show={isOpen === "L2"}>
      <Dropdown.Toggle className="bg-color opacity-button" id="dropdown-basic" onClick={() => handleClick("L2")}>
         L2 Español
      </Dropdown.Toggle>
  <Dropdown.Menu>

<Dropdown.Item onClick={() => setSelectedMenu("Workshop")}> 
Workshop
    {selectedMenu === "Workshop" && (
      <Dropdown.Menu className="dropdown-menu-right">
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓 Workshop Series StarkNet 01 ㅤㅤㅤㅤㅤIntroducción a L2"); window.open("https://www.youtube.com/watch?v=s6vmWYkZoa8", "_blank");}}>👨‍🎓 Workshop 1 - Introducción a L2</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓 Workshop Series StarkNet 02 ㅤㅤㅤㅤㅤEcosistema Starknet"); window.open("https://www.youtube.com/watch?v=KxUhBM3a6oM", "_blank");}}>👨‍🎓 Workshop 2 - Ecosistema Starknet</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓 Workshop Series StarkNet 03 ㅤㅤㅤㅤㅤCreando en Starknet"); window.open("https://www.youtube.com/watch?v=elXLye41_b8", "_blank");}}>👨‍🎓 Workshop 3 - Creando en Starknet</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓 Workshop Series StarkNet 04 ㅤㅤㅤㅤㅤDesplegando en Starknet. Parte 1 (Creando NFT)"); window.open("https://www.youtube.com/watch?v=y3rJnaNRiGI", "_blank");}}>👨‍🎓 Workshop 4 - Desplegando en Starknet. Parte 1 (Creando NFT)</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓 Workshop Series StarkNet 05 ㅤㅤㅤㅤㅤDesplegando en Starknet. Parte 2 (Uri y Metadata ERC-721"); window.open("https://www.youtube.com/watch?v=SnaZjW2p3Io", "_blank");}}>👨‍🎓 Workshop 5 - Desplegando en Starknet. Parte 1 (Creando NFT)</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓 Workshop Series StarkNet 06 ㅤㅤㅤㅤㅤAccount Abstraction. Parte 1"); window.open("https://www.youtube.com/watch?v=flnTFmEnjEQ", "_blank");}}>👨‍🎓 Workshop 6 - Account Abstraction. Parte 1</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓 Workshop Series StarkNet 07 ㅤㅤㅤㅤㅤAccount Abstraction. Parte 2"); window.open("https://www.youtube.com/watch?v=6vdP329tK_I", "_blank");}}>👨‍🎓 Workshop 7 - Account Abstraction. Parte 2</Dropdown.Item>
</Dropdown.Menu>
)}

</Dropdown.Item>
<Dropdown.Item onClick={() => setSelectedMenu("Mirror")}> 
Mirror
    {selectedMenu === "Mirror" && (
<Dropdown.Menu >
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤEste es un primer listado de preguntas frecuentes que tienen la intención de explicar de la forma más sencilla pero correcta posible sobre los fundamentos teóricos de la soluciones de escalabilidad de Ethereum."); window.open("https://mirror.xyz/layer2es.eth/ng4uMLEKLPquP7ubRbJlE6IctNrFCkLUKBYlgnQEcbk", "_blank");}}>👨‍🎓 Preguntas frecuentes sobre L2 de Ethereum. Parte 1</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤLuego de una primera edición con preguntas esenciales para entender cómo y porqué están las L2 en Ethereum, es momento de una segunda compilación de preguntas y curiosidades sobre esta tecnología."); window.open("https://mirror.xyz/layer2es.eth/RJwxJtLAtfV3kW85vKt4_42J6dLMrFHEjxAUqLAmsNA", "_blank");}}>👨‍🎓 Preguntas frecuentes sobre L2 de Ethereum. Parte 2</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤPara conmemorar el próximo lanzamiento de Arbitrum Nitro el 31 de Agosto, hemos preparado para L2 en Español un resumen+revisión de los aspectos más importantes del reciente paper de Nitro."); window.open("https://mirror.xyz/layer2es.eth/NgFuZ8eJmuKKI1zDk7XFyuH-s61xXFEJG22tp3teZS0", "_blank");}}>👨‍🎓 Revisando el whitepaper de Arbitrum Nitro</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤEste artículo está basado en buena medida en el artículo de Vitalik Buterin llamado “Que tipo de Layer 3 tienen sentido?” y otras fuentes."); window.open("https://mirror.xyz/layer2es.eth/xIzByUO_Jr_uDvAJivvYEi4CCg8lawaAiQrlWUH81ik", "_blank");}}>👨‍🎓 Layer 3 y el punto de vista de Vitalik</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤEn este documento en especial nos centraremos en los Workshop 6-7 sobre Account Abstraction, aprenderemos como calcular una address antes de ser deployada y crear nuestro Contrato de Cuenta."); window.open("https://mirror.xyz/layer2es.eth/UXaZqiBlaxGULKUjWon7KPswx8J8UpUlkuYdFt_hzmA", "_blank");}}>👨‍🎓 Recap Workshop ¿Cómo deployar una Account Abstraction en Starknet?</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤEste artículo es una traducción de un artículo escrito por Matt Finestone sobre la descentralización de los rollups y el approach que Taiko está utilizando para lograr esto."); window.open("https://mirror.xyz/layer2es.eth/bMrhfiLuKGVVXyX-CyvxTnmgB4OXpMyaZ8wype7UfqE", "_blank");}}>👨‍🎓 Descentralización de Rollups</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤEsta publicación es una traducción del articulo publicado por Polynya."); window.open("https://mirror.xyz/layer2es.eth/RRcOADKIozR99SelK5vxtSswDQwhne61RH_aIVZ_k34", "_blank");}}>👨‍🎓 Por qué los rollups pueden ofrecer un mayor rendimiento que la L1</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤUna comparación entre las zkEVM a modo usuario, técnicos y experiencias en algunas pruebas realizadas. Entre ellas compararemos 5 (Taiko, Scroll, zkSync 2.0, Polygon zkEVM y ConsenSys)"); window.open("https://mirror.xyz/layer2es.eth/YPGL8m1ve2aA_Ql6496f4yjuxkU1NIUSDM4EH6u10i0", "_blank");}}>👨‍🎓 Comparando las zkEVM en testnet</Dropdown.Item>
</Dropdown.Menu>
)}


</Dropdown.Item>
<Dropdown.Item onClick={() => setSelectedMenu("Youtube")}> 
Youtube
    {selectedMenu === "Youtube" && (
<Dropdown.Menu>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤIntroducción y Concpetos báscicos a las Layer 2"); window.open("https://www.youtube.com/watch?v=u2ZW6WKxOz0", "_blank");}}>🎥  Ep. 001: Introducción a L2 con Joxes y Diego</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤEs tiempo de poner foco en los riesgos que tenemos que tener en cuenta si deseamos transitar en estas redes. "); window.open("https://www.youtube.com/watch?v=aEQHcuaVPsM", "_blank");}}>🎥  Ep. 002: Los riesgos de usar L2</Dropdown.Item>
</Dropdown.Menu>
)}

</Dropdown.Item>
<Dropdown.Item onClick={() => setSelectedMenu("Space")}> 
Space
    {selectedMenu === "Space" && (
<Dropdown.Menu>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTwitterSpaces junto a la comunidad amiga de Layer2es, con un invitado muy especial GonnaEth 🙌🏼."); window.open("https://twitter.com/OptimismESP/status/1618253716091723776", "_blank");}}>Optimism Español 🔴✨ - Novedades de un futuro optimista</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTwitterSpaces con camiinthisthang de (fuellabs ⚡ )y iamnicki15 & josefabregab de (MetisDAO🌿) para hablar de cadenas optimistas aseguradas por Ethereum!"); window.open("https://twitter.com/Layer2es/status/1600263732567113730", "_blank");}}>L2 WARS Optimismo 🔴✨ - Fuel & Metis</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTwitterSpaces contaremos con espejelomar de (StarkWareLtd) y FilosofiaCodigo de (Scroll) para hablar de la nueva generación de ZK Rollups y el concepto de la zkEVM 🚀"); window.open("https://twitter.com/Layer2es/status/1595196000376946688", "_blank");}}>L2 WARS Optimismo 🔴✨ - zkEVM en Español ¿Qué significa zkEVM? Starknet & Scroll</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTwitterSpaces para hablar de esto y nuestras impresiones de las L2 en la (DevconVI) junto a Axlvaz, CATTlN, 0xJoxes y nicoproducto"); window.open("https://twitter.com/Layer2es/status/1587199515232243714", "_blank");}}>L2 WARS Optimismo 🔴✨ - ¿Quien está ganando?, ¿Optimistic o ZK Rollups?</Dropdown.Item>

</Dropdown.Menu>
)}

</Dropdown.Item>
<Dropdown.Item onClick={() => setSelectedMenu("Contact")}> 
Contact
    {selectedMenu === "Contact" && (
<Dropdown.Menu>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤUna comunidad dedicada al estudio de soluciones de escalabilidad de Ethereum ⟠"); window.open("https://twitter.com/Layer2es", "_blank");}}>🔵 Twitter - l2espaniol</Dropdown.Item>
<Dropdown.Item href="#" onClick={() => {alert("👨‍🎓L2 Español👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤUna comunidad dedicada al estudio de soluciones de escalabilidad de Ethereum ⟠"); window.open("https://t.me/l2espaniol", "_blank");}}>🔵 Telegram - l2espaniol</Dropdown.Item>
</Dropdown.Menu>
)}

</Dropdown.Item>
</Dropdown.Menu>
</Dropdown>
<Dropdown className="starknet-es" show={isOpen === "ST"}>
    <Dropdown.Toggle className="bg-color opacity-button" id="dropdown-basic" onClick={() => handleClick("ST")}>
        StarknetEs
    </Dropdown.Toggle>
<Dropdown.Menu>
<Dropdown.Item onClick={() => setSelectedMenu("Workshop")}> 
    Workshop
    {selectedMenu === "Workshop" && (
      <Dropdown.Menu className="center">
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Jueves Cairol👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTodos los Jueves se habla sobre lo que esta pasando en el ecosistema de Starknet y Cairo"); window.open("https://www.youtube.com/watch?v=4D11ejpK0iQ", "_blank");}}>👨‍🎓 Jueves de Cairo - 1</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Jueves Cairol👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTodos los Jueves se habla sobre lo que esta pasando en el ecosistema de Starknet y Cairo"); window.open("https://www.youtube.com/watch?v=istF-lBqiXk", "_blank");}}>👨‍🎓 Jueves de Cairo - 2</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Jueves Cairol👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTodos los Jueves se habla sobre lo que esta pasando en el ecosistema de Starknet y Cairo"); window.open("https://www.youtube.com/watch?v=L0dX2vohHq0", "_blank");}}>👨‍🎓 Jueves de Cairo - 3</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Jueves Cairol👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤTodos los Jueves se habla sobre lo que esta pasando en el ecosistema de Starknet y Cairo"); window.open("https://www.youtube.com/watch?v=dBPYL6SY4jk", "_blank");}}>👨‍🎓 Jueves de Cairo - 4</Dropdown.Item>
</Dropdown.Menu>
)}

</Dropdown.Item>
<Dropdown.Item onClick={() => setSelectedMenu("Contact")}> 
    Contact
    {selectedMenu === "Contact" && (
      <Dropdown.Menu>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓StarknetEsl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤUna comunidad en Español dedicada al estudio y desarrollo de Starknet en General"); window.open("https://twitter.com/StarkNetEs", "_blank");}}>🔵 Twitter - StarknetEs</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓StarknetEsl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤUna comunidad en Español dedicada al estudio y desarrollo de Starknet en General"); window.open("https://t.me/starknet_es", "_blank");}}>🔵 Telegram - StarknetEs</Dropdown.Item>
</Dropdown.Menu>
)}

</Dropdown.Item>
<Dropdown.Item onClick={() => setSelectedMenu("Github")}> 
    Github
    {selectedMenu === "Github" && (
      <Dropdown.Menu>
        <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓StarknetEs Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤOrganización oficial en Español en Github dedicada al estudio y desarrollo de Starknet en General"); window.open("https://github.com/Starknet-Es", "_blank");}}>👨‍💻 Github - StarknetEs</Dropdown.Item>
</Dropdown.Menu>
)}




</Dropdown.Item>
           </Dropdown.Menu>
            </Dropdown>
            <Dropdown className="contact" show={isOpen === "C"}>
             <Dropdown.Toggle className="bg-color opacity-button" id="dropdown-basic" onClick={() => handleClick("C")}>
            Contact
            </Dropdown.Toggle>
            <Dropdown.Menu>
            <Dropdown.Item href="https://twitter.com/Nadai02010">Twitter</Dropdown.Item>
            <Dropdown.Item href="#">Telegram</Dropdown.Item>
            </Dropdown.Menu>

            </Dropdown>
            <Dropdown className="github-nadai" show={isOpen === "GN"}>
            <Dropdown.Toggle className="bg-color opacity-button" id="dropdown-basic"  onClick={() => handleClick("GN")}>
            Github Nadai
            </Dropdown.Toggle>
            <Dropdown.Menu>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai Min-Starknet"); window.open("https://github.com/Nadai2010/min-starknet", "_blank");}}>👨‍🎓 Nadai MIN-STARKNET (Minimos Recursos para deployar)</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai SHARP-Starknet"); window.open("https://github.com/Nadai2010/Nadai-SHARP-Starknet", "_blank");}}>👨‍🎓 Nadai SHARP-STARKNET.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai L2Español Comparativa ZkEVM"); window.open("https://github.com/Nadai2010/Nadai-L2-ESP-Comparativa-ZkEVM", "_blank");}}>👨‍🎓 Nadai L2Es-Comparativa zkEVM.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai ERC3525-Starknet"); window.open("https://github.com/Nadai2010/Nadai-ERC3525-Starknet", "_blank");}}>👨‍🎓 Nadai ERC3525-STARKNET.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai NaiProxyV2-Starknet ERC20"); window.open("https://github.com/Nadai2010/Nadai-NaiProxyV2-Starknet-ERC20", "_blank");}}>👨‍🎓 Nadai NaiProxyV2-Starknet ERC20.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai STARKNET-Edu Guía Bridge-L2-L1"); window.open("https://github.com/Nadai2010/Nadai-Starknet-Edu-Bridge-L2-L1", "_blank");}}>👨‍🎓 Nadai STARKNET-Edu Guía Bridge-L2-L1.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai STARKNET-Edu Guía ERC-721"); window.open("https://github.com/Nadai2010/Nadai-Cairo-721-Starknet-Edu", "_blank");}}>👨‍🎓 Nadai STARKNET-Edu Guía ERC-721.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai STARKNET-Edu Guía 101"); window.open("https://github.com/Nadai2010/Nadai-Cairo-101-Starknet", "_blank");}}>👨‍🎓 Nadai STARKNET-Edu Guía 101.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai STARKNET Guía Cairo-Mummies"); window.open("https://github.com/Nadai2010/Nadai-Cairo-Mummies", "_blank");}}>👨‍🎓 Nadai STARKNET Guía Cairo-Mummies.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai STARKNET Guía Cairo-Mummies2"); window.open("https://github.com/Nadai2010/Nadai-Cairo-Mummies-2", "_blank");}}>👨‍🎓 Nadai STARKNET Guía Cairo-Mummies2.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai Workshop L2Español & StarknetEs AA"); window.open("https://github.com/Nadai2010/Nadai-Workshop-L2-Starknet-AA", "_blank");}}>👨‍🎓 Nadai Workshop L2Español & StarknetEs AA.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai Guía UDC con POAP ERC-721 L2Español & StarknetEs"); window.open("https://github.com/Nadai2010/Nadai-Starknet-UDC-Protostar-L2ESERC721", "_blank");}}>👨‍🎓 Nadai Guía UDC con POAP ERC-721 L2Español & StarknetEs.</Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => {alert("👨‍🎓Nadai Githubl👨‍🎓ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤAcceder a la Repo de Nadai Guía NFT Dinámico Oráculo Chainlink"); window.open("https://github.com/Nadai2010/Nadai-Chainlink-dNFT", "_blank");}}>👨‍🎓 Nadai Guía NFT Dinámico Oráculo Chainlink, diferentes diseños NADAIMON.</Dropdown.Item>
            </Dropdown.Menu>
            </Dropdown>
            </Nav>
          </Navbar.Collapse>
    <StarknetConfig connectors={connectors}>
   <InjectWallet/>
   <ConnectionStatus/>
   </StarknetConfig>
          </Navbar>

 
<div style={{height: '100px'}}></div>      
<div class="background-container">
    <img src={backgroundImg1} class="background-image1" alt="background" />
    <img src={backgroundImg2} class="background-image2" alt="background" />
</div>
      <div class="main-container">
      <div className="main-container">
      <div className="text-container">
      <h1 class="text-color">Soluciones de Escalabilidad Layer 2</h1>
      <img src={logo} className="App-logo" alt="logo" />
      <h2 class="text-color2">Información de las principales Optimistic Rollup y Zk Rollup en Layer 2</h2>
      <p>
      </p>
<div style={{height: '30px'}}></div>

<div className="container"> 
<div className="row">
<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id1 ? 'open' : ''}`} onClick={handleCard1Open}> 
  <div className="card-front"> 
  <img src={image1} alt="Starknet" className={`${openCard === id1 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard1} onHide={handleCard1Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://starknet.io/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤㅤSTARKNETㅤㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ StarkNet es un Validity-Rollup descentralizado sin permiso (a menudo denominado ZK-Rollup). </p>
  <p>Opera como una red L2 sobre Ethereum, lo que permite que cualquier dApp alcance una escala ilimitada para su cálculo, sin comprometer la compatibilidad y la seguridad de Ethereum.</p>
  <p>✨✨Validity Proof✨✨:</p>
  <p>Inventados por StarkWare, imponen la integridad y la privacidad de los cálculos en cadenas de bloques, utilizando pruebas criptográficas novedosas y álgebra moderna. Los ZK-STARK permiten que las cadenas de bloques trasladen los cálculos a un único probador STARK fuera de la cadena y luego verifiquen la integridad de esos cálculos utilizando un Verificador STARK en la cadena.</p>
  <p><a href="https://starknet.io/">Información Oficial Starknet</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/starknet">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card1} alt="Starknet" className="image-center1"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard1Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>

<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id2 ? 'open' : ''}`} onClick={handleCard2Open}> 
  <div className="card-front"> 
  <img src={image2} alt="Arbitrum" className={`${openCard === id2 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard2} onHide={handleCard2Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://arbitrum.io/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤㅤARBITRUMㅤㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ Arbitrum es un Optimistic Rollup que tiene como objetivo sentirse exactamente como interactuar con Ethereum.</p>
  <p> Con transacciones que cuestan una fracción de lo que cuestan en L1. El secuenciador centralizado recibe las transacciones de los usuarios y envía regularmente el lote de transacciones a la red principal Ethereum. Los validadores independientes (actualmente incluidos en la lista blanca) leen los lotes de transacciones de L1, los ejecutan y envían una raíz de estado de L2 resultante a L1. Cualquier otro validador puede desafiar la raíz del estado dentro de la ventana de desafío (7 días). </p>
  <p>✨✨Fraud Proof✨✨:</p>
  <p>Las pruebas de fraude aseguran la corrección del estado Después de un período de tiempo, se supone que la raíz de estado publicada es correcta. Durante un cierto período de tiempo, generalmente una semana, uno de los actores incluidos en la lista blanca puede presentar una prueba de fraude que demuestre que el estado era incorrecto.</p>
  <p><a href="https://arbitrum.io/">Información Oficial Arbitrum</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/arbitrum">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card2} alt="Arbitrum" className="image-center2"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard2Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>

<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id3 ? 'open' : ''}`} onClick={handleCard3Open}> 
  <div className="card-front"> 
  <img src={image3} alt="Optimism" className={`${openCard === id3 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard3} onHide={handleCard3Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://optimism.io/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤㅤOPTIMISMㅤㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ Optimism es una cadena de bloques L2, Optimistic Rollup compatible con EVM. </p>
  <p>Optimism es rápida, estable y escalable creada por desarrolladores de Ethereum, para desarrolladores de Ethereum. Construida como una extensión mínima del software Ethereum existente, la arquitectura equivalente a EVM de Optimism escala sus aplicaciones Ethereum sin sorpresas. Si funciona en Ethereum, funciona en Optimism a una fracción del costo.</p>
  <p>✨✨Fraud Proof✨✨:</p>
  <p>Las pruebas de fraude aseguran la corrección del estado Después de un período de tiempo, se supone que la raíz de estado publicada es correcta. Durante un cierto período de tiempo, generalmente una semana, uno de los actores incluidos en la lista blanca puede presentar una prueba de fraude que demuestre que el estado era incorrecto.</p>
  <p><a href="https://optimism.io/">Información Oficial Optimism</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/optimism">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card3} alt="Optimism" className="image-center3"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard3Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>

<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id4 ? 'open' : ''}`} onClick={handleCard4Open}> 
  <div className="card-front"> 
  <img src={image4} alt="Starknet" className={`${openCard === id4 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard4} onHide={handleCard4Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://zksync.io/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤㅤZK SYNCㅤㅤㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ zkSync es un zk-Rollup, un protocolo sin confianza que utiliza pruebas de validez criptográfica para proporcionar transacciones escalables y de bajo costo en Ethereum.</p>
  <p>zkSync 2.0 está hecho para verse y sentirse como Ethereum, pero con tarifas más bajas. Al igual que en Ethereum, los contratos inteligentes se escriben en Solidity/Vyper y se pueden llamar utilizando los mismos clientes que las otras cadenas compatibles con EVM.</p>
  <p>✨✨ZK Proof✨✨:</p>
  <p>En los rollups ZK ('ZK' significa conocimiento cero), el lote de transacciones se verifica para verificar su corrección en la red Ethereum. Una vez que pasa la verificación, el lote de transacciones se considera final como cualquier otra transacción de Ethereum. Esto se logra mediante el poder de las pruebas de validez criptográfica (Validity Proof o ZK Proof). En zkSync, esto se hace a través de un argumento de conocimiento sucinto no interactivo SNARK.</p>
  <p><a href="https://zksync.io/">Información Oficial Starknet</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/zksync">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card4} alt="zkSync" className="image-center4"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard4Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>
<div style={{height: '50px'}}></div>

<div className="container"> 
<div className="row">
<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id5 ? 'open' : ''}`} onClick={handleCard5Open}> 
  <div className="card-front"> 
  <img src={image5} alt="Starknet" className={`${openCard === id5 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard5} onHide={handleCard5Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://dydx.exchange/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤㅤDYDXㅤㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ dYdX usa StarkWare Layer 2 para ofrecer algunos de sus productos, como los mercados de contratos perpetuos utilazando criptografía STARK de Zero knowledge.</p>
  <p>dYdX tiene como objetivo construir un intercambio poderoso y profesional para el comercio de activos criptográficos donde los usuarios puedan realmente ser dueños de sus operaciones y, eventualmente, del intercambio en sí.</p>
  <p>✨✨Validity Proof✨✨:</p>
  <p>Cada actualización del estado del sistema debe ir acompañada de una prueba ZK que asegure que el nuevo estado se obtuvo al aplicar correctamente una serie de transacciones de usuario válidas al estado anterior. Una vez que la prueba se procesa en la cadena de bloques de Ethereum, el bloque L2 se finaliza instantáneamente. El estado del sistema se representa mediante raíces de Merkle.</p>
  <p><a href="https://dydx.exchange/">Información Oficial dydX</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/dydx">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card5} alt="Dydx" className="image-center5"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard5Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>

<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id6 ? 'open' : ''}`} onClick={handleCard6Open}> 
  <div className="card-front"> 
  <img src={image6} alt="Metis" className={`${openCard === id6 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard6} onHide={handleCard6Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://www.metis.io/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤㅤMETISㅤㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ Metis es una solución de escalado equivalente a EVM originalmente bifurcada de Optimism.</p>
  <p>  Metis ofrece varias soluciones para resolver los grandes desafíos que enfrentamos en la red principal de Ethereum, incluida la velocidad de transacción, el costo y la escalabilidad. Brinda soporte para múltiples cadenas L2 interconectadas con un enfoque principal en soportar la fácil creación de DAC (Compañías Autónomas Descentralizadas), </p>
  <p>✨✨Fraud Proof✨✨:</p>
  <p>Las pruebas de fraude aseguran la corrección del estado Después de un período de tiempo, se supone que la raíz de estado publicada es correcta. Durante un cierto período de tiempo, generalmente una semana, uno de los actores incluidos en la lista blanca puede presentar una prueba de fraude que demuestre que el estado era incorrecto.</p>
  <p><a href="https://www.metis.io/">Información Oficial Metis</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/metis">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card6} alt="Metis" className="image-center6"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard6Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>

<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id7 ? 'open' : ''}`} onClick={handleCard7Open}> 
  <div className="card-front"> 
  <img src={image7} alt="Loopring" className={`${openCard === id7 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard7} onHide={handleCard7Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://loopring.org/#/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤㅤLOOPRINGㅤㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ Loopring es una solución Zk Rollup L2 que tiene como objetivo ofrecer las mismas garantías de seguridad que la red principal de Ethereum. </p>
  <p>En Loopring Protocol 3, han mejorado significativamente el rendimiento del protocolo. Esto ha sido mediante el uso de pruebas zkSNARK: la mayor cantidad de trabajo posible se realiza fuera de la cadena y solo verificamos el trabajo en la cadena.</p>
  <p>✨✨Validity Proof✨✨:</p>
  <p>Cada actualización del estado del sistema debe ir acompañada de una prueba ZK que asegure que el nuevo estado se obtuvo al aplicar correctamente una serie de transacciones de usuario válidas al estado anterior. Una vez que la prueba se procesa en la cadena de bloques de Ethereum, el bloque L2 se finaliza instantáneamente. El estado del sistema se representa mediante raíces de Merkle.</p>
  <p><a href="https://loopring.org/#/">Información Oficial Loopring</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/loopring">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card7} alt="Looprng" className="image-center7"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard7Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>

<div className="col-sm-3 text-center">
  <Card className={`card ${openCard === id8 ? 'open' : ''}`} onClick={handleCard8Open}> 
  <div className="card-front"> 
  <img src={image8} alt="Immutable" className={`${openCard === id8 ? 'hidden' : ''}`}/>
  </div>
  </Card>
  </div>
  <Modal show={showCard8} onHide={handleCard8Close}>
  <Modal.Header closeButton>
  <Modal.Title className="text-center title-center">  <a className="App-link" href="https://www.immutable.com/" target="_blank" rel="noopener noreferrer" >ㅤㅤㅤㅤㅤㅤIMMUTABLEXㅤㅤㅤㅤ</a></Modal.Title>
</Modal.Header>
<Modal.Body className="text-justify" >
  <p>⚫ Immutable X afirma ser la primera capa 2 para NFT en Ethereum. Promete tarifas de gasolina cero, intercambios instantáneos y escalabilidad para juegos, aplicaciones, mercados, sin compromiso.</p>
  <p>Immutable X usa StarkEx, un motor de escalabilidad impulsado por STARK para intercambios de criptomonedas. StarkEx utiliza pruebas criptográficas para dar fe de la validez de un lote de transacciones (como intercambios y transferencias) y actualiza un compromiso con el estado del intercambio en cadena. 2.0 está hecho para verse y sentirse como Ethereum, pero con tarifas más bajas.</p>
  <p>✨✨Validity Proof✨✨:</p>
  <p>Cada actualización del estado del sistema debe ir acompañada de una prueba ZK que asegure que el nuevo estado se obtuvo al aplicar correctamente una serie de transacciones de usuario válidas al estado anterior. Una vez que la prueba se procesa en la cadena de bloques de Ethereum, el bloque L2 se finaliza instantáneamente. El estado del sistema se representa mediante raíces de Merkle.</p>
  <p><a href="https://www.immutable.com/">Información Oficial Immutable X</a> </p>
  <p><a href="https://l2beat.com/scaling/projects/immutablex">Link Info L2Beat</a> </p>
  <p><a href="https://l2fees.info/">Fee L2Fee</a> </p>
  <img src={Card8} alt="Immutable" className="image-center8"/>
</Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={handleCard8Close}>
  Cerrar
  </Button>
  </Modal.Footer>
</Modal>
<div style={{borderTop: '5px solid #ccc', margin: '100px 0'}} />
<h1 class="text-color">Ecosistema StarkNet</h1>
<h2 class="text-color2">Proyectos desarrollados dentro del ecositema de Starknet.</h2>
<div style={{height: '50px'}}></div>

</div>
</div>

</div>
</div>
<EcoStarknet /> 
<div>
</div>
<div style={{borderTop: '5px solid #ccc', margin: '100px 0'}} />
<h1 class="text-color">StarknetEs Comunidad</h1>
<h2 class="text-color2">StarkNianos, aquí podrán añadir y revisar las iniciativas</h2>
<h2 class="text-color2">de los miembros de la comunidad Starknet en Español</h2>
<div style={{height: '50px'}}></div>
<StarknetEs /> 
</div>
</div>
</div>
</div>






  );
};




export default App;